import { render, staticRenderFns } from "./ReactSendMailable.vue?vue&type=template&id=1fa7a098&"
import script from "./ReactSendMailable.vue?vue&type=script&lang=js&"
export * from "./ReactSendMailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports